var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelivery = function SvgDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "M9.538 4.718h3.077a2.05 2.05 0 0 1 2.052 2.051v4.103h-1.539"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "M2.359 10.872H1.333v-7.18A1.026 1.026 0 0 1 2.36 2.667h6.154a1.026 1.026 0 0 1 1.025 1.025v5.826M9.026 10.872H6.462"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "M11.077 12.923a2.051 2.051 0 1 1 0-4.102 2.051 2.051 0 0 1 0 4.102M4.41 12.923a2.051 2.051 0 1 1 0-4.102 2.051 2.051 0 0 1 0 4.102"
  })));
};
export default SvgDelivery;